define('customPlugins/atnAutoHideNotification',[
        'knockout', 'lodash', 'jquery'
    ],
    function(ko, _, $) {
        'use strict';
        
        //this is the time after which the notification messages,
        //seen on the top of the UI pages ,will dissappear.
        var NOTIFICATION_TIMEOUT_INTERVAL = 8000;

        ko.bindingHandlers.atnAutoHideNotification = {
            update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
                var showStatus = valueAccessor();
                if (showStatus()) {
                    _.delay(function() {
                        showStatus(false);
                    }, NOTIFICATION_TIMEOUT_INTERVAL);

                }
                ko.bindingHandlers.visible.update(element, valueAccessor, allBindings, viewModel, bindingContext);
            },
        };
    });
